export default "__VITE_ASSET__BGlRMy81__"